@if (slice.primary.image) {
  <div class="plans-hero-bg" role="img" aria-label="promotional image" [ngStyle]="getStyles(slice)">
    <div class="mask flex-center" [ngClass]="{'rgba-black-strong': slice.primary?.overlay_tint == 'dark', 'rgba-white-light': slice.primary?.overlay_tint == 'light'}" >
    </div>
  </div>
}
